import React, { useEffect, useState } from "react";
import "./WorkSub.css";

import HeroImage from "../../assets/work/hero-image.png";
import BgDecor from "../../assets/work/bg-decor.png";
import Mockup1 from "../../assets/work/mockup1.png";
import Mockup2 from "../../assets/work/mockup2.png";
import DesignGuide from "../../assets/work/design-guide.png";
import { useParams } from "react-router-dom";
import API_BASE_URL from "../../config";
import bgWork from "../../assets/work/work-test-bg.png";
import { motion } from "framer-motion";

const WorkSub = () => {
  const { slug } = useParams();
  const [project, setproject] = useState(null);
  const [loading, setLoading] = useState(true);

  const [imageLoader, setImageLoader] = useState({
    large: true,
    small: true,
  });
  const [textLoaded, setTextLoaded] = useState(false);
  useEffect(() => {
    if (!loading && project) {
      setTimeout(() => setTextLoaded(true), 100); // slight delay for smoother fade
    }
  }, [loading, project]);

  useEffect(() => {
    console.log(slug);
    setTimeout(() => {
      fetchProject();
    }, 300);
  }, []);

  const fetchProject = () => {
    try {
      fetch(`${API_BASE_URL}/work-projects/${slug}`)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          setproject(data);
        })
        .catch((err) => console.error("Error fetching projects:", err));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const styleBgColor = {
    31: "#673D3D",
    1: "#E18060",
    33: "#5C6E8D",
    32: "#007BFF",
    30: "#FF5F5D",
  };

  return (
    <>
      {loading ? (
        <div
          className="custom-loader"
          style={{
            height: "65vh",
            width: "100vw",
            position: "relative",
            zIndex: "1",
            display: "flex",
            alignContent: "center",
          }}
        >
          <div className="dots-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : (
        <div className="worksub-container">
          {/* Hero Section */}
          <section className="hero-section">
            <div
              className="bg-decor"
              style={{ backgroundColor: styleBgColor[project?.id] }}
            ></div>
            <div className="hero-content">
              <div
                className={`hero-content ${
                  textLoaded ? "loaded" : "loading-text"
                }`}
              >
                <div className="inner-1">
                  <div className="inner-11">
                    <p className="worksub-subtitle">{project?.subtitle}</p>
                    <p className="title">{project?.title}</p>
                  </div>
                  <div className="inner-12">
                    {project?.info || "project-info"}
                  </div>
                </div>
                <div className="inner-2">
                  <div className="inner-21">
                    <p className="subtitle">Industry</p>
                    <p className="title">{project?.industry}</p>
                  </div>
                  <div className="inner-21">
                    <p className="subtitle">Project Type</p>
                    <p className="title">{project?.project_type}</p>
                  </div>
                  <div className="inner-21">
                    <p className="subtitle">Technology Stack</p>
                    <p className="title">Industry</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="image-container">
              {/* Large Image */}
              {imageLoader.large && (
                <div className="shimmer large-shimmer"></div>
              )}
              <img
                src={project?.bg_url}
                alt="Large"
                className={`large-img ${!imageLoader.large ? "loaded" : ""}`}
                onLoad={() =>
                  setImageLoader((prev) => ({ ...prev, large: false }))
                }
              />

              {/* Small Image */}
              <div className="small-img-container">
                {imageLoader.small && (
                  <div className="shimmer small-shimmer"></div>
                )}
                <img
                  src={project?.image_url}
                  alt="Small"
                  className={`small-image ${
                    !imageLoader.small ? "loaded" : ""
                  }`}
                  onLoad={() =>
                    setImageLoader((prev) => ({ ...prev, small: false }))
                  }
                />
              </div>
            </div>
          </section>

          {project?.content != null &&
            project.content.map((section, idx) => (
               <motion.div
                      initial={{ opacity: 0, y: 100 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.8 }}
                      viewport={{ once: true }}
                    >
              <section className="worksub-section" key={idx}>
                {section.image && (
                  <img
                    src={section.image}
                    alt={section.header}
                    className="worksub-image"
                  />
                )}

                <h2>{section.header}</h2>

                {section.childType === "text" && (
                  <p
                    className="textofsections"
                    style={{
                      whiteSpace: "pre-line",
                      fontFamily: '"Aeonik TRIAL",sans-serif',
                    }}
                  >
                    {section.child}
                  </p>
                )}

                {section.childType === "table" && (
                  <ul style={{ cursor: "pointer" }}>
                    {section.child.map((item, i) => (
                      <li key={i} className="textofsections">
                        <strong>{item.header}:</strong> {item.text}
                      </li>
                    ))}
                  </ul>
                )}

                {section.childType === "typography" && (
                  <div
                    className="worksub-section1"
                    style={{ fontFamily: section?.child[0]?.fontFamily }}
                  >
                    <div className="inner-text">
                      <h2>Font used</h2>
                    </div>
                    <div className="inner-font-style-section">
                      <h1>
                        {section?.child[0]?.fontFamily?.match(/'([^']+)'/)[1] ||
                          "Inter"}
                      </h1>
                      <p style={{ fontFamily: section?.child[0]?.fontFamily }}>
                        {section.child[0]?.aboutFont}
                      </p>
                    </div>
                    <div className="inner2">
                      <p style={{ fontFamily: section?.child[0]?.fontFamily }}>
                        ABCDEFGHIJKLMNOPQRSTUVWXYZ
                      </p>
                      <p style={{ fontFamily: section?.child[0]?.fontFamily }}>
                        abcdefghijklmnopqrstuvwxyz
                      </p>
                    </div>
                    <div class="inner3">
                      <p>1234567890</p>
                    </div>
                    <div className="around-inner-dec">
                      <div className="inner-dec">
                        <div
                          className="font-left"
                          style={{ fontFamily: section?.child[0]?.fontFamily }}
                        >
                          <p className="text-interbold"  style={{ fontFamily: `${section?.child[0]?.fontFamily}` }}> {section?.child[0]?.fontFamily?.match(/'([^']+)'/)[1] ||
                          "Inter"} Bold</p>
                          <p className="inter-ragular"  style={{ fontFamily: `${section?.child[0]?.fontFamily}` }}> {section?.child[0]?.fontFamily?.match(/'([^']+)'/)[1] ||
                          "Inter"} Regular</p>
                        </div>

                        <div
                          className="font-right"
                          style={{ fontFamily: section?.child[0]?.fontFamily }}
                        >
                          <p className="inter-light"  style={{ fontFamily: `${section?.child[0]?.fontFamily}` }}> {section?.child[0]?.fontFamily?.match(/'([^']+)'/)[1] ||
                          "Inter"} Light</p>
                          <p className="inter-medium"  style={{ fontFamily: `${section?.child[0]?.fontFamily}` }}> {section?.child[0]?.fontFamily?.match(/'([^']+)'/)[1] ||
                          "Inter"} Medium</p>
                        </div>
                      </div>
                    </div>
                    <div className="inner4">
                      <h4>Color Used</h4>
                    </div>
                    <div className="inner5">
                      {section?.child[0]?.colors?.map((color, index) => (
                        <div key={index}>
                          <div
                            class="irregular-circle"
                            style={{ backgroundColor: color.value }}
                          ></div>
                          <p
                            style={{
                              margin: 0,
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {color.key}
                          </p>
                          <p
                            style={{
                              margin: 0,
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {color.value}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </section>
              </motion.div>
            ))}

          {project?.content === null && (
            <>
              {/* About Section */}
              <section className="worksub-section">
                <h2>About the project</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec
                  vulputate erat vitae libero eleifend, eu feugiat nulla
                  feugiat.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor porta mauris, sed laoreet massa feugiat eu.
                </p>
              </section>

              <img src={Mockup1} alt="Mockup 1" className="worksub-image" />

              {/* Features Section */}
              <section className="worksub-section">
                <h2>Exclusive features</h2>
                <ul>
                  <li>
                    <strong>Real-Time Collaboration</strong>
                    <br />
                    Enables teams to work together live on design projects.
                  </li>
                  <li>
                    <strong>AR & 3D Visualization</strong>
                    <br />
                    Visualize interiors before implementation.
                  </li>
                  <li>
                    <strong>Article Listing, Details & Search</strong>
                    <br />
                    Full content flow with search support.
                  </li>
                  <li>
                    <strong>Clean & Intuitive Interface</strong>
                    <br />
                    Minimal design with smooth navigation.
                  </li>
                </ul>
              </section>

              <img src={Mockup2} alt="Mockup 2" className="worksub-image" />

              {/* Designing Section */}
              <section className="worksub-section">
                <h2>Designing OnTrack</h2>
                <ul>
                  <li>
                    <strong>UX Research:</strong> We conducted 15+ user
                    interviews...
                  </li>
                  <li>
                    <strong>Low-Fidelity (Lo-Fi) Prototype:</strong> 60+
                    wireframes...
                  </li>
                  <li>
                    <strong>High-Fidelity (Hi-Fi) Prototype:</strong> 700+
                    screens...
                  </li>
                  <li>
                    <strong>Over 500 Interface Screens:</strong> Customized by
                    module
                  </li>
                  <li>
                    <strong>A Comprehensive UI Kit and Brandbook:</strong> For a
                    consistent identity
                  </li>
                </ul>
              </section>

              <img
                src={DesignGuide}
                alt="Design Guide"
                className="worksub-image"
              />

              {/* Key Challenge */}
              <section className="worksub-section">
                <h2>Key challenge</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer nec justo id libero imperdiet sagittis.
                </p>
              </section>

              {/* Solutions */}
              <section className="worksub-section">
                <h2>Our solutions</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur eu suscipit erat.
                </p>
              </section>

              {/* Impact */}
              <section className="worksub-section">
                <h2>Impact</h2>
                <p>
                  Significant reduction in turnaround time and enhanced team
                  collaboration.
                </p>
              </section>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default WorkSub;
